import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {new Date().getFullYear()} Jan Kwiatkowski</p>
      </div>
    </footer>
  );
};

export default Footer;
